<template>
  <tr>
    <td
      v-for="(cell, index) in tableCols"
      :key="index"
      class="py-2 px-3"
      :class="this.aligning[index]"
    >
      <!-- prettier-ignore -->
      <contenteditable
        tag="span"
        :modelValue="tableCols[index]"
        :contenteditable="edit"
        @update:modelValue="updateColumn(index, $event)"
        @focus="focusedIndex = index"
        @blur="focusedIndex = null"
        :noNL="true"
        :noHTML="true"
        :alwaysSelectAll="$t('Col value')"
        @updated="updated = 'cols'"
      />
    </td>

    <td v-if="edit" class="cursor-pointer text-lg" @click="deleteElement()">
      x
    </td>
  </tr>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'

export default {
  mixins: [BaseElement],
  props: ['aligning', 'firstRow'],
  data() {
    return {
      focusedIndex: null
    }
  },

  computed: {
    tableCols() {
      const arr = []
      this.aligning.forEach((element, index) => {
        if (element === 'text-right' && this.focusedIndex !== index) {
          arr.push(this.numberFormat(this.data.cols[index]))
        } else {
          arr.push(this.data.cols[index])
        }
      })
      return arr
    }
  },
  methods: {
    updateColumn(index, data) {
      this.data.cols[index] = data
    },
    numberFormat(number, decimals, decPoint, thousandsSep) {
      // eslint-disable-line camelcase
      number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
      var n = !isFinite(+number) ? 0 : +number
      var prec = decimals === undefined ? (n.toString().split('.')[1] || '').length : Math.abs(decimals)
      var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep
      var dec = typeof decPoint === 'undefined' ? '.' : decPoint
      var s = ''
      var toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec)
        return '' + (Math.round(n * k) / k).toFixed(prec)
      }
      // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
      }
      return s.join(dec)
    }
  }
}
</script>

<style lang="scss" scoped></style>
